/**
 * GraphQL Mutations for Deployment API
 */

/**
 * Mutation to update metadata item content
 */
export const UPDATE_METADATA_ITEM_MUTATION = `
  mutation UpdateMetadataItem($input: UpdateMetadataItemInput!) {
    updateMetadataItem(input: $input) {
      id
      metadataType
      fullName
      fileName
      content
      sha256Hash
      toolingEnriched
      insertedAt
      updatedAt
      isEdited
      status
      organization {
        id
        orgName
      }
      metadataRetrieval {
        id
        status
      }
    }
  }
`;

/**
 * Mutation to deploy metadata items
 * Note: retrievalId is NOT required (unlike queries)
 */
export const DEPLOY_METADATA_MUTATION = `
  mutation DeployMetadata($input: DeployMetadataInput!) {
    deployMetadata(input: $input) {
      id
      status
      asyncProcessId
      deployOptions
      errorMessage
      startedAt
      completedAt
      insertedAt
      updatedAt
      organization {
        id
        orgName
      }
      metadataItems {
        id
        metadataType
        fullName
        fileName
      }
    }
  }
`;

/**
 * Mutation to upload multiple metadata files
 */
export const UPLOAD_METADATA_FILES_MUTATION = `
  mutation UploadMetadataFiles($input: UploadMetadataFilesInput!) {
    uploadMetadataFiles(input: $input) {
      created {
        id
        metadataType
        fullName
        fileName
        content
      }
      updated {
        id
        metadataType
        fullName
        fileName
        content
      }
      errors {
        index
        filename
        error
      }
    }
  }
`;

